"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@material-ui/core");
var _saraivaUi = require("@minha-biblioteca/saraiva-ui");
var _FileCopyOutlined = _interopRequireDefault(require("@material-ui/icons/FileCopyOutlined"));
var _ReadMoreText = _interopRequireDefault(require("../ReadMoreText"));
var _styles = _interopRequireDefault(require("./styles"));
var _contexts = require("../../contexts");
var _services = require("../../services");
var _copy = require("../../constants/copy");
var _utils = require("../../utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable react/jsx-no-bind */

var CopyDiv = props => {
  var {
    title,
    reference,
    abntProp,
    onCopy
  } = props;
  var classes = (0, _styles.default)();
  var matches = (0, _core.useMediaQuery)('(min-width:769px)');
  var [snackBar, setSnackBar] = (0, _react.useState)(false);
  var {
    bookFile,
    rendition,
    sessionToken,
    uuid,
    bookTitle
  } = (0, _react.useContext)(_contexts.EpubReaderContext);
  var {
    copyOrigin
  } = (0, _react.useContext)(_contexts.CopyrightContext);
  var getAbntContent = () => {
    if (!abntProp) return '';
    return "(".concat((0, _utils.formatAuthorAbnt)(bookFile.abnt.split(' ')[0] || 'author'), " ").concat(bookFile.editionYear, ", p.").concat(rendition.location.start.location, ")");
  };
  var getReference = () => abntProp ? "\"".concat(reference, "\" ").concat(getAbntContent()) : reference;
  var appToken = (0, _utils.appTokenCase)(window.location.origin);
  var trackService = (0, _services.TrackingsService)(appToken, sessionToken);
  var trackingTextCopy = () => {
    trackService.trackCopyText({
      uuid,
      titleCover: bookTitle,
      sessionToken,
      copyOrigin,
      copyText: getReference(),
      copyType: abntProp ? _copy.TYPE.ABNT_TEXT : _copy.TYPE.PLAIN_TEXT,
      bookPage: rendition.location.start.location
    });
  };
  var copyToClipBoard = () => {
    trackingTextCopy();
    var value = getReference();
    setSnackBar(true);
    navigator.clipboard.writeText(value);
    setTimeout(() => {
      setSnackBar(false);
    }, 5000);
    onCopy(value);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    onContextMenu: e => e.preventDefault(),
    className: abntProp && classes.copyDiv
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.top
  }, /*#__PURE__*/_react.default.createElement("h6", {
    className: matches ? classes.title : classes.titleMobile
  }, title), /*#__PURE__*/_react.default.createElement(_saraivaUi.Button, {
    color: "secondary",
    onClick: copyToClipBoard,
    startIcon: /*#__PURE__*/_react.default.createElement(_FileCopyOutlined.default, {
      style: {
        margin: 0
      }
    })
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: classes.copyBtnLabel
  }, matches ? 'Copiar' : ''))), /*#__PURE__*/_react.default.createElement(_ReadMoreText.default, {
    textClassName: matches ? classes.reference : classes.referenceMobile,
    detailText: getAbntContent(),
    text: getReference(),
    lines: 3
  })), snackBar && /*#__PURE__*/_react.default.createElement("div", {
    className: matches ? classes.snackBar : classes.snackBarMobile
  }, /*#__PURE__*/_react.default.createElement(_saraivaUi.Snackbar, {
    severity: "success",
    noClose: true,
    show: snackBar
  }, abntProp ? 'Citação direta copiada para a área de transferência.' : 'Trecho copiado para área de transferência.')));
};
CopyDiv.propTypes = {
  title: _propTypes.default.string.isRequired,
  reference: _propTypes.default.string.isRequired,
  abntProp: _propTypes.default.bool,
  onCopy: _propTypes.default.func.isRequired
};
CopyDiv.defaultProps = {
  abntProp: false
};
var _default = exports.default = CopyDiv;